import { render, staticRenderFns } from "./PolicyHolderHeader.vue?vue&type=template&id=c2f5a506"
import script from "./PolicyHolderHeader.vue?vue&type=script&lang=js"
export * from "./PolicyHolderHeader.vue?vue&type=script&lang=js"
import style0 from "./PolicyHolderHeader.vue?vue&type=style&index=0&id=c2f5a506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports